import {
	CategoryKeys,
	type QuestionIDType,
	QuestionsKeys,
} from 'help/types/types'

export const getQuestionsWithoutInactiveOrders = ({
	isLoyalty,
	likes,
	birthDate,
}: {
	isLoyalty: boolean | undefined
	likes: number | undefined
	birthDate: string | undefined
}) => {
	const questionsList: QuestionIDType[] = []
	if (!isLoyalty) {
		questionsList.push({
			categoryKey: CategoryKeys.payments,
			questionKey: QuestionsKeys.paymentMethods,
		})
		questionsList.push({
			categoryKey: CategoryKeys.payments,
			questionKey: QuestionsKeys.useGiftCard,
		})
		questionsList.push({
			categoryKey: CategoryKeys.productInfo,
			questionKey: QuestionsKeys.sizeGuide,
		})
	} else {
		if (!likes && birthDate) {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.discoverClub,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.getLikes,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.sizeGuide,
			})
		} else if (birthDate) {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.useLikes,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.sizeGuide,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.benefits,
			})
		} else if (likes) {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.birthdayGift,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.useLikes,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.sizeGuide,
			})
		} else {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.birthdayGift,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.discoverClub,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.sizeGuide,
			})
		}
	}
	return questionsList
}

export const getQuestionsWithInactiveOrders = ({
	isLoyalty,
	likes,
	birthDate,
}: {
	isLoyalty: boolean | undefined
	likes: number | undefined
	birthDate: string | undefined
}) => {
	const questionsList: QuestionIDType[] = []
	if (!isLoyalty) {
		questionsList.push({
			categoryKey: CategoryKeys.productInfo,
			questionKey: QuestionsKeys.garmentCare,
		})
		questionsList.push({
			categoryKey: CategoryKeys.payments,
			questionKey: QuestionsKeys.useGiftCard,
		})
	} else {
		if (!likes && birthDate) {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.discoverClub,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.getLikes,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			})
		} else if (birthDate) {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.useLikes,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.benefits,
			})
		} else if (likes) {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.birthdayGift,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.useLikes,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			})
		} else {
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.birthdayGift,
			})
			questionsList.push({
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.discoverClub,
			})
			questionsList.push({
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			})
		}
	}
	return questionsList
}
